import React from 'react';
/**
 * Used in the "Branded" background effect to display a floating logo in the bottom left corner of the video
 */
const BrandedEffectFloatingLogo = ({ src }) => (<div 
/**
 * TODO: Somehow grab these styles from call-frames-branded-logo.scss (unfortunately linting prevents importing .scss files here...?)
 */
style={{
        position: 'absolute',
        bottom: 4,
        left: 4,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        padding: '4px 6px',
        borderRadius: 6,
        backdropFilter: 'blur(12px)',
    }}>
    <img width={100} src={src} alt="Logo"/>
  </div>);
export default BrandedEffectFloatingLogo;
